<script lang="ts" setup>
import IconInfo from '@lahaus-roomie/roomie/src/assets/icons/info.svg'
import RoomieTooltip from '@lahaus-roomie/roomie/src/components/RoomieTooltip/index.vue'

import { ref } from 'vue'

const { t, tm, rt } = useI18n()

const tooltipOptions = tm('tooltipOptions') as Array<any>

const showTooltip = ref(false)
</script>

<script lang="ts">

export default {
  name: 'PdInvestSafe'
}
</script>

<template>
  <section
    id="pd-invest-safe"
    class="bg-primary-50 lg:rounded-md px-24 py-32 md:py-32 md:px-48">
    <div>
      <img
        src="https://media.lahaus.com/statics/roomie/pictograms/security.svg"
        alt="icono seguridad"
        class="w-56 h-56 mb-16">

      <h3 class="text-carbon-800 font-semibold text-24  md:text-32 leading-28 lg:leading-[3.5rem]">
        {{ t('part1') }}
        <span class="text-primary-600">
          {{ t('part2') }}
        </span>
      </h3>
    </div>

    <div class="mt-16 relative">
      <button
        id="pd-invest-safe-button-tooltip"
        data-lh-id="pd-invest-safe-button-tooltip"
        type="button"
        :aria-label="t('knowMore')"
        class="text-primary-600 font-medium flex items-center gap-6"
        @mouseover="showTooltip = true"
        @mouseleave="showTooltip = false">
        {{ t('knowMore') }}
        <IconInfo class="w-16 h-16 fill-primary-600 pointer-events-none" />
      </button>

      <RoomieTooltip
        id="pd-invest-safe-tooltip"
        bottom="2.8rem"
        indicator-right="7.2rem"
        variant="message"
        indicator-placement="bottom center"
        :title="t('tooltipTitle')"
        :is-visible="showTooltip"
        @tooltip-closed="showTooltip = false">
        <template #description>
          <ul class="pl-16">
            <li
              v-for="option, index in tooltipOptions"
              :key="index"
              class="list-disc">
              {{ rt(option) }}
            </li>
          </ul>
        </template>
      </RoomieTooltip>
    </div>
  </section>
</template>
<i18n src="./i18n.json" lang="json"></i18n>
